export default "__VITE_ASSET__BpDB_lHM__"